import { render, staticRenderFns } from "./TiersStocks.vue?vue&type=template&id=0904a6b4&"
import script from "./TiersStocks.vue?vue&type=script&lang=js&"
export * from "./TiersStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports